import { Component } from '@angular/core';
import { ResizeDetectionService } from '../../services/resize-detection.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent {
  cookiePopupVisibility: boolean = false;
  customCookiePopupVisibility: boolean = false;
  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;
  selectedSection: string = 'General Information:';

  faqData = new Map<string, {image: string, faqs: Array<{header: string, body: string}>}>([    
    ['General Information:', {
      image: 'assets/images/general-info-faq.svg',
      faqs: [
        {
          header: "What is NutriGenic?",
          body: 'Simply NutriGienic is a leading meal prep company that specializes in delivering wholesome, healthy meals made from real ingredients, without any chemicals or additives. We use only the highest quality ingredients, carefully selected to ensure optimal nutrition and taste. Our meals are crafted by expert chefs who bring their culinary expertise to every dish. We place a strong emphasis on community and customer care, offering direct support whenever needed.'
        },
        {
          header: "What makes NutriGenic different from other meal prep companies?",
          body: 'We are an elite team of food, nutrition, and fitness experts, driven by a firm commitment to sustainability in every aspect of our operations. Our dedicated focus on sustainability encompasses every step, from responsibly sourcing environmentally friendly materials to reducing waste and minimizing our carbon footprint. We integrate these sustainable practices as fundamental elements of our business model, striving to protect natural resources and lessen our impact on the planet. Moreover, this dedication extends to our partnerships and suppliers, collaboratively promoting environmentally conscious practices across our entire supply chain.'
        },
        {
          header: "Who's the Founder?",
          body: 'Our culinary venture was sparked by the vision of our dedicated founder, Taoufik Hannachi, a highly skilled chef with more than twenty years of culinary experience. His mastery of culinary arts and unwavering commitment to creating exceptional dishes are at the heart of our mission. Driven by a passion for excellence and a desire to craft unforgettable dining experiences. His innovative approach and steadfast focus on customer satisfaction have empowered us to revolutionize the meal delivery experience.'
        }
      ]
    }],
    ['How it works:', {
      image: 'assets/images/how-it-works-faq.svg',
      faqs: [
        {
          header: "How do I get started?",
          body: 'Our plan is tailored to accommodate your dietary goals and preferences. We provide a 8 weeks minimum subscription for a flexible week length. Subscribers benefit from significant discounts and the convenience of automated renewal. You can further customize your plan with expert guidance to meet specific dietary needs. We also offer breakfasts and snacks to ensure comprehensive daily nutrition. Creating your personalized plan is straightforward—just follow our simple steps to customize it according to your preferences.'
        },
        {
          header: "How much does it cost?",
          body: "The cost is £9.50 per meal, and you can enjoy substantial discounts through our automated subscription option."
        },
        {
          header: "How does the ordering and payment process for my plan work?",
          body: "As a subscription-based service you will be charged weekly and your whole plan will be automatically renewed once expired. This ensures convenience and continuity in enjoying our offerings. If you want to disable the auto-renew see on the Manage Subscription FAQ section how to do it it."
        },
        {
          header: "How can I contact NutriGenic if I have a question or issue?",
          body: 'To get in touch with us, please feel free to email us at <a href="mailto:support@nutrigenic.co.uk">support@nutrigenic.co.uk</a> or message us on our Business WhatsApp at +44 753 873 4145. We are here to provide dedicated support and assist you with any queries you may have.'
        },
        {
          header: "How do you accommodate allergies?",
          body: "NutriGenic meals are suitable for dairy and gluten intolerances. When ordering, please indicate any allergens you have. This will help identify meals that contain the allergen(s) you\'ve selected. For a comprehensive list of ingredients, including allergens, please refer to our menu page. While we make every effort to remove bones and shells, some may still be present."
        },
        {
          header: "Can I pause deliveries?",
          body: "You can easily pause deliveries at any time after the second week. Go to Managing Subscription FAQ section for more details."
        },
        {
          header: "Can I cancel my subscription?",
          body: "Yes. You can cancel your subscription at any time after the second week. Go to Managing Subscription FAQ section for more details."
        }
      ]
    }],
    ['Managing Subscription:', {
      image: 'assets/images/manage-subscription-faq.svg',
      faqs: [
        {
          header: "How do I manage my NutriGenic subscription?",
          body: "You can manage your subscription directly through your My Account section on our website. This includes selecting meals, skipping weeks, pausing your plan, or cancelling in line with your scheduled deliveries.<br><br>For the cut-off times see the related faq of this section."
        },
        {
          header: "Can I pause my subscription?",
          body: "Yes. You can pause your subscription whenever you need to through your account online, with no penalties or long-term commitment. <br><br> How to pause your subscription:<ol><li>Go to My Account</li><li>Select Orders</li><li>Choose your active order and select Pause</li><li>Select the dates you'd like to pause and confirm</li></ol>"
        },
        {
          header: "Can I skip a delivery?",
          body: "Absolutely. If you don't need a delivery for a particular week, you can skip it easily before the weekly cut-off time. <br><br>To skip a delivery, follow the same steps as pausing:<ol><li>Go to My Account</li><li>Select Orders</li><li>Choose your active order and select Pause</li><li>Select the relevant dates and confirm</li></ol>"
        },
        {
          header: "How do I change my meals?",
          body: "You can update your meal selection through your online account during the ordering window. Once the cut-off has passed, changes will apply to the following delivery.<br><br>How to change meals:<ol><li>Go to My Account</li><li>Select Orders</li><li>Choose your active order</li><li>Select Change meals on your next delivery</li><li>You can also apply these changes to all upcoming deliveries by ticking the box “Apply to all remaining weeks“</li></ol>"
        },
        {
          header: "How do I update my delivery address?",
          body: "To update your delivery address you have two ways: <br><br>From <strong>My Orders</strong> section <ol><li>Access the Details of the Order you want to amend the address for</li><li>Find the address and click on Edit</li></ol> <br> Asking us: <ul><li>Send an email at <a href=\"mailto:support@nutrigenic.co.uk\">support@nutrigenic.co.uk</a> and our team will make the change for you.</li></ul> <br>Please make sure to change your address <strong>before the relevant cut-off time</strong> to ensure the update applies to your next delivery"
        },
        {
          header: "Can I cancel my subscription?",
          body: "Yes. You can cancel your subscription at any time after the second week through your account.<br><br>How to Cancel my subscription: <ol><li>Go to My Account</li><li>Select Orders</li><li>Choose your active order</li><li>Scroll all the way to the bottom and follow the steps by requesting cancellation on the date you chose</li></ol>"
        },
        {
          header: "What happens if I forget to make changes?",
          body: "If no changes are made before the cut-off, your order will be processed as scheduled using your most recent meal selections, delivery and payment details"
        },
        {
          header: "When is the weekly cut-off time for changes?",
          body: "The cut-off time for meal selections, skips, pauses, and other changes is on: <br><br> <ul><li>Tuesday till 11pm for Saturday's deliveries</li> <li>Saturday till 11pm for Wednesday's deliveries</li></ul>. Any updates made after the cut-off will apply to the following delivery."
        },
        {
          header: "I'm having trouble accessing my account, what should I do?",
          body: "If you're experiencing any issues, our customer care team is happy to help. We offer real human support, not impersonal AI chatbots.<br> Please email us on <a href=\"mailto:support@nutrigenic.co.uk\">support@nutrigenic.co.uk</a>"
        },
        {
          header: "How do I stop the subscription auto-renewal?",
          body: "To stop the subscription auto-renewal simply get in touch with us at <a href=\"mailto:support@nutrigenic.co.uk\">support@nutrigenic.co.uk</a> or message us on our Business WhatsApp at +44 753 873 4145 and we'll do it for you."
        },
      ]
    }],
    ['Nutrition and ingredients:', {
      image: 'assets/images/nutrition-and-ingredients-faq.svg',
      faqs: [
        {
          header: "Is all your ingredients Halal?",
          body: "Certainly! Our kitchen strictly adheres to using only halal ingredients, ensuring there are no non-halal ingredients present in our facilities."
        },
        {
          header: "Are all your ingredients high quality?",
          body: "Absolutely! We are dedicated to using exclusively high-quality ingredients that are free from chemicals, vegetable oils, and added sugars. Our commitment to purity and natural flavors ensures that every dish we create is not only delicious but also meets the highest standards of health and taste"
        },
        {
          header: "Do you use additives, preservatives, oil, sugars etc.?",
          body: "Absolutely not. We do not use additives, preservatives, vegetable oils, or added sugars in our products. We prioritize natural ingredients and maintain a commitment to providing wholesome, healthy options for our customers."
        },
        {
          header: "Are your meals nutritionally balanced?",
          body: "Yes, our meals are carefully crafted to be nutritionally balanced, offering three different diet-suitable options. We ensure that each dish incorporates a thoughtful combination of essential nutrients, proteins, carbohydrates, vitamins, and minerals to support a healthy diet tailored to different dietary preferences and needs."
        }
      ]
    }],
    ['Packaging & Deliveries:', {
      image: 'assets/images/packaging-and-delivery-faq.svg',
      faqs: [
        {
          header: "Can I recycle the packaging?",
          body: "Yes, our packaging is crafted from polypropylene material, which is fully recyclable and safe for microwave use. We prioritize environmental sustainability while ensuring customer health and safety."
        },
        {
          header: "Can I heat the meals in the oven?",
          body: "Our meals are delivered in polypropylene material, which is considered the most suitable resin for the production ofmicrowave food reheat containers. While we do not provide specific oven heating instructions, you can transfer the food into an oven-safe dish if preferred. Always ensure your meals are thoroughly heated before consuming."
        },
        {
          header: "How long do the meals last?",
          body: "Due to our commitment to using no artificial preservatives and in compliance with food safety regulations for pre-prepared food, we strictly follow the labeling \"use by\" date on each meal. When stored in a refrigerator, our meals typically last for 3 days."
        },
        {
          header: "What days do you deliver?",
          body: "Wednesdays and Saturdays. However, delivery days vary depending on your plan type. We offer either once or twice-weekly delivery schedules because our meals are freshly made."
        },
        {
          header: "What areas do you deliver to?",
          body: "We offer delivery Nationwide across the entire UK."
        },
        {
          header: "What if I'm not going to be home?",
          body: "If you won't be home for delivery, don't worry! During checkout, you can provide delivery instructions for the driver, such as a designated safe place. On the day of delivery, you'll receive a text message where you can update these instructions, such as leaving the parcel with a neighbour or at your front door. You can track your delivery and view proof of delivery through your tracking link, which includes a photo showing where the parcel was left."
        }
      ]
    }],
    ['Nutrition Support:', {
      image: 'assets/images/nutrition-support-faq.svg',
      faqs: []
    }],
  ]);

  constructor(private sizedetection: ResizeDetectionService) {}

  
  
  ngOnInit() {
    if (localStorage.getItem('cookie')) {
      this.cookiePopupVisibility = false;
    } else this.cookiePopupVisibility = true;
    this.sizedetection.refreshSize();
    this.sizedetection.sizeCondition$.subscribe(data => {
      this.isDesktop = data.isDesktop;
      this.isTablet = data.isTablet;
      this.isMobile = data.isMobile;
    });
  }

  getFaqEntries() {
    return Array.from(this.faqData.entries());
  }

  trackByIndex(index: number): number {
    return index;
  }

  selectSection(section: string) {
    this.selectedSection = section;
    this.scrollToElement('faq-accordions');
  }

  getSelectedFaqSection() {
    const entry = Array.from(this.faqData.entries()).find(([key]) => key === this.selectedSection);
    return entry ? entry[1].faqs : [];
  }

  getSelectedSectionName() {
    return this.selectedSection;
  }

  
  acceptCookie() {
    localStorage.setItem('cookie', "1");
    this.cookiePopupVisibility = false;
  }
  customizeCookie() {
    this.cookiePopupVisibility = false;
    this.customCookiePopupVisibility = true;
  }
  rejectCookie() {
    this.cookiePopupVisibility = false;
  }
  acceptCookieOpen() {
    localStorage.setItem('cookie', "1");
    this.cookiePopupVisibility = false;
  }
  customizeCookieOpen() {
    localStorage.setItem('cookie', "1");
    this.customCookiePopupVisibility = false;
  }
  rejectCookieOpen() {
    this.customCookiePopupVisibility = true;
  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  }
}
